/**
 * Gedämpfte Bewegung — `prefers-reduced-motion` an **einem** Ort.
 *
 * Angelegt am 24.09.2026, nachdem der `usability-reviewer` beim Review zu Schritt 7
 * festgestellt hat, dass es die Einstellung im ganzen Prototyp nirgends gab. Es gibt
 * bislang genau **eine** Bewegung — das weiche Hereinscrollen der Bodenlinie in
 * `src/Reihe.tsx`, aus Schritt 4. Die Lücke ist damit heute klein; sie wüchse aber mit
 * jeder weiteren Animation unbemerkt mit, und genau das ist der Grund, dass hier eine
 * Datei steht und nicht eine Bedingung an der Fundstelle.
 *
 * *Wen das betrifft:* Menschen, denen von bewegten Oberflächen schwindlig oder übel wird.
 * Sie haben die Einstellung im Betriebssystem gesetzt, und eine Seite, die sie übergeht,
 * ist für sie nicht unbequem, sondern unbenutzbar.
 */

export const REDUZIERTE_BEWEGUNG = "(prefers-reduced-motion: reduce)";

/**
 * Wie gescrollt wird. Rein, damit ein Test die Regel prüfen kann, ohne ein `window` zu
 * bauen — dieselbe Trennung wie zwischen `shared/rahmen.ts` und `src/lib/rahmen.ts`.
 */
export function scrollVerhalten(reduziert: boolean): ScrollBehavior {
  return reduziert ? "auto" : "smooth";
}

/**
 * Ob das Gerät gedämpfte Bewegung verlangt.
 *
 * Im Zweifel **nein**: fehlt `matchMedia` oder wirft die Abfrage, wird weich gescrollt wie
 * bisher. Eine fehlende Fähigkeit des Browsers ist kein Wunsch der Nutzerin.
 */
export function bewegungReduziert(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  try {
    return window.matchMedia(REDUZIERTE_BEWEGUNG).matches;
  } catch {
    return false;
  }
}

/** Was `scrollIntoView` bekommt. Die eine Zeile, die die Oberfläche aufruft. */
export function sanftesScrollen(): ScrollBehavior {
  return scrollVerhalten(bewegungReduziert());
}
